import { RestMutationOptions, useRestMutation } from 'src/hooks/useRestMutation';
import { PaymentApiList } from 'src/stores/payments/apis';
import { PaymentsCompleteRequest, PaymentsCompleteResponse } from 'src/types/Payments';

export const useCompletePaymentMutation = (
  options: RestMutationOptions<PaymentsCompleteRequest, PaymentsCompleteResponse> = {}
) => {
  return useRestMutation<PaymentsCompleteRequest, PaymentsCompleteResponse>({
    path: PaymentApiList.CompletePayment,
    method: 'post',
    options,
  });
};
